import { useId } from 'react'
import type { LucideIcon } from 'lucide-react'

/** Composição adaptada do Statistics Card 10 (21st.dev).
 * Referências e decisões em docs/ESTILO-VISUAL.md; estilos na folha global.
 */
export function MetricCard({ label, value, detail, icon: Icon, featured = false }: {
  label: string
  value: string
  detail: string
  icon: LucideIcon
  featured?: boolean
}) {
  const titleId = useId()
  return <article className={`metric-card${featured ? ' featured' : ''}`} aria-labelledby={titleId}>
    <header className="metric-card-header">
      <span className="metric-icon" aria-hidden="true"><Icon/></span>
      <h2 id={titleId}>{label}</h2>
    </header>
    <strong className="metric-card-value">{value}</strong>
    <footer className="metric-card-context"><span aria-hidden="true"/>{detail}</footer>
  </article>
}
